import { Outlet, createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { VStack } from '@/components/Layout';

import { Header } from './-components';

const organizationSearchSchema = z.object({
  baseDate: z.string().optional(),
});

export const Route = createFileRoute('/_staff/organization/$id/_layout')({
  component: Layout,
  validateSearch: zodValidator(organizationSearchSchema),
});

function Layout() {
  return (
    <VStack>
      <Header />
      <Outlet />
    </VStack>
  );
}
